import { atom } from 'jotai';

import type { TDashboardUx } from '@lib/types/generated/TPermission';

export type TAppState = Readonly<{
  isSidebarOpen: boolean;
  dashboard: TDashboardUx[];
}>;

const INITIAL_APP_STATE = {
  isSidebarOpen: false,
  dashboard: ['default'],
} satisfies TAppState;

/**
 * This atom holds metadata about the current state of
 * the app. Please do not introduce global state meant only for business logic here.
 *
 * Possible candidates:
 *   - currentPage
 *   - currentPath
 *   - isSidebarOpen
 *   - isUserLoggedIn
 */
const appAtom = atom<TAppState>(INITIAL_APP_STATE);

export { appAtom };
